import { all, put, takeEvery } from 'redux-saga/effects';
import { analyticsActions } from '../analytics/actions/AnalyticsActions.creators';
import { GeneralActionTypes } from '../../enums/ActionEnums';
import { EventEnum } from '@as-react/common-types';
import { watchForCustomEvents } from './customEventSagaHandler';
function* customEventSaga() {
    yield takeEvery(GeneralActionTypes.CUSTOM_EVENT, handleCustomEvent);
}
function* handleCustomEvent(action) {
    switch (action.payload.eventType) {
        case EventEnum.MOBILE_NAVIGATION_CLICK:
            yield put(analyticsActions.mobileNavigationClick());
            break;
        default:
            break;
    }
}
export default function* () {
    yield all([watchForCustomEvents(), customEventSaga()]);
}
